// メッセージだけ表示するアラート
module.exports = App.Views.Base.extend({
  el: '.js-simple-message-alert',
  events: {
    'click .js-btn-close': 'hide'
  },
  props: {
    duration: 150
  },
  show: function(message) {
    // @TODO iOSのみ対応済み(デザイン)
    if (App.me.is_android) {
      alert(message);
      return;
    }
    $('.js-description', this.$el).html(message);
    this.$el.fadeIn(this.props.duration);
  },
  hide: function() {
    this.$el.fadeOut(this.props.duration);
  }
});



// WEBPACK FOOTER //
// ./webroot/js/sp/views/simple-message-alert.js